// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmPayoutError-ErrorTitle_cls1__1FI2o","cls2":"ConfirmPayoutError-ErrorTitle_cls2__rs-vD ConfirmPayoutError-ErrorTitle_cls1__1FI2o"};